// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"372":"054bbf96","385":"eacc30ca","395":"100d3d81","526":"58992853","574":"067cac9f","718":"2c097e83","894":"bf2f0b2b","959":"3e0c7541"}[chunkId] + ".css";
};